import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { VendorService } from '../../../services/vendor.service';
import { PrintService } from '../../../services/print.service';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
	selector: 'app-vendordash-payments',
	templateUrl: './vendordash-payments.component.html',
	styleUrls: ['./vendordash-payments.component.scss'],
	animations: [
	  trigger('flipState', [
		  state('active', style({
			  transform: 'rotate3d(0, 1, 0, 179deg)',
		  })),
		  state('inactive', style({
			  transform: 'rotateY(0)'
		  })),
		  transition('active => inactive', animate('500ms ease-out')),
		  transition('inactive => active', animate('500ms ease-in')),
	  ]),
	]
})
export class VendordashPaymentsComponent implements OnInit {
	flip = 'inactive';
	@Output() viewData = new EventEmitter<any>();

	payments: any = [];
	viewing: any = false;
	title: any = '';
	exporting = false;
	@ViewChild('print_table') printtable: ElementRef;

	constructor(
		private vendorService: VendorService,
		private printService: PrintService,
		private globalSearchService: GlobalSearchService
	) {}

	ngOnInit(): void {
		this.vendorService.getDashBoard().subscribe((results: any) => {
			if (results && results.payments) {
				this.payments = results.payments;
			}
		});
	}

	toggleFlip(data: any, title: string) {
		if (!data) {
			this.flip = 'inactive';
		} else {
			this.flip = (this.flip == 'active') ? 'inactive' : 'active';
		}

		if (this.flip == 'active') {
			this.viewing = data;
			this.title = title;
			const dashboard_data = { data: data, title: 'Payments' };
			this.viewData.emit(dashboard_data);
		} else {
			this.viewing = false;
			this.viewData.emit(false);
		}
	}

	exportPdf() {
		this.exporting = true;
		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const today = new Date();
		const data = {
			content: encoded,
			filename: 'payments.pdf',
			landscape: true,
			title: 'Payments',
			subtitle: 'Created ' + today.toLocaleString()
		};
		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
			this.exporting = false;
		});
	}

	exportXls() {
		this.exporting = true;
		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const today = new Date();
		const data = {
			content: encoded,
			filename: 'payments.xlsx',
			title: 'Payments',
			subtitle: 'Created ' + today.toLocaleString()
		};
		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
			this.exporting = false;
		});
	}

}
